module.exports = __webpack_public_path__ + "img/c766b3fed5654234bfc71d8d1cede7ff.dfe38afe.jpg";